module.exports = {"systemVersion":"1.0.46.2025066"}


//////////////////
// WEBPACK FOOTER
// ./static/js/version.json
// module id = taDY
// module chunks = 87